import React from "react";
import { searchService } from "../../../services/searchService";
import { sanitizedHtml } from "../../../utils/sanitize";

function Articles({ programSiteId }) {
  const [articles, setArticles] = React.useState(null);

  React.useEffect(() => {
    if (!programSiteId) return;
    searchService.getArticles(programSiteId)
      .then((data) => {
        setArticles(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        setArticles([]);
      });
  }, [programSiteId]);

  if (!articles || articles.length === 0) return null;

  return (
    <>
      <div className="page-break" />
      <section className="card-highlight reading">
        <label className="label">Suggested Reading</label>
        <div className="information-data articles-region">
          <div className="articles">
            {articles.map((article, i) => (
              <div className="article" key={article.number || i} dangerouslySetInnerHTML={sanitizedHtml(article.description)} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Articles;
